import { render, staticRenderFns } from "./CardProductionBoxComponent.vue?vue&type=template&id=ef137174&"
import script from "./CardProductionBoxComponent.vue?vue&type=script&lang=ts&"
export * from "./CardProductionBoxComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports